module.exports = __webpack_public_path__ + "img/endorphina.c1540966.svg";